module.exports = __webpack_public_path__ + "img/PORT13.b1788742.jpg";